export const GET_PROCUREMENTS: { [x: string]: any } = {
  LOADING: "PROCUREMENTS_GET_LOADING",
  SUCCESS: "PROCUREMENTS_GET_SUCCESS",
  ERROR: "PROCUREMENTS_GET_ERROR",
};

export const GET_PROCUREMENT: { [x: string]: any } = {
  LOADING: "PROCUREMENT_GET_LOADING",
  SUCCESS: "PROCUREMENT_GET_SUCCESS",
  ERROR: "PROCUREMENT_GET_ERROR",
};

export const CREATE_PROCUREMENT: { [x: string]: any } = {
  LOADING: "PROCUREMENT_CREATE_LOADING",
  SUCCESS: "PROCUREMENT_CREATE_SUCCESS",
  ERROR: "PROCUREMENT_CREATE_ERROR",
};

export const UPDATE_PROCUREMENT: { [x: string]: any } = {
  LOADING: "PROCUREMENT_UPDATE_LOADING",
  SUCCESS: "PROCUREMENT_UPDATE_SUCCESS",
  ERROR: "PROCUREMENT_UPDATE_ERROR",
};

//   export const DELETE_PROCUREMENT: { [x: string]: any } = {
//     LOADING: "PROCUREMENT_DELETE_LOADING",
//     SUCCESS: "PROCUREMENT_DELETE_SUCCESS",
//     ERROR: "PROCUREMENT_DELETE_ERROR",
//   };
